<template>
    <div class="skill-table">
        <div class="skill-table__level has-text-centered">
            <h2 class="is-size-3 skill-table__level__icon">
                <level-icon :level="level" size="is-large" />
            </h2>

            <div class="has-text-centered is-inline-block">
                <h5 class="is-size-6 is-pulled-left has-text-primary">{{$t('students.profile.level')}}</h5>
                <br />

                <h2 class="is-size-3 skill-table__level__name">
                    {{$t(`levels.${level.name}.name`)}}
                </h2>
            </div>
        </div>

        <div class="columns is-multiline">
            <div v-for="skill in skills" class="column is-4-desktop is-6-touch">
                <h4 class="is-size-6 has-text-primary">
                    <router-link :to="{name: 'skills.skill', params: {group: skill.skill_group.name, skill: skill.name}}">
                        {{$t(`skills.${skill.name}.name`)}}
                    </router-link>
                </h4>

                <h3 class="is-size-5">
                    <price :pay-grade="paygrade(skill)" />
                </h3>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../../global/styles/variables';

    .skill-table {
        .skill-table__level {
            margin-bottom: 50px;

            .skill-table__level__name {
                a {
                    color: $grey-dark;

                    &:hover {
                        color: $primary;
                    }
                }
            }
        }
    }
</style>

<script>
    import LevelIcon from '@/taskflex/levels/components/LevelIcon';
    import Price from '@/taskflex/skills/components/Price';

    export default {
        props: {
            student: {
                type: Object,
                required: true,
            },
        },

        computed: {
            level() {
                const { level } = this.student;

                return level;
            },

            skills() {
                const { skills } = this.student;

                return skills;
            },
        },

        methods: {
            paygrade(skill) {
                return skill.paygrades.find(paygrade => paygrade.level_id === this.level.id);
            },
        },

        components: {
            LevelIcon,
            Price,
        },
    };
</script>


// WEBPACK FOOTER //
// src/taskflex/students/components/profile/SkillTable.vue